import { frontendURL, backendApiURL, backendURL, authURL } from './globalEnvConfig';

// Update this type to match the environment variables you want to use
export type envVars = {
  BACKEND_URL: string;
  DEFAULT_ACTION: string;
  DEFAULT_VARIANT: string;
  FRONTEND_URL: string;
  PEGA_APP: string;
  INACTIVITY_TIMEOUT_MS: number;
  OIDC_AUTHORITY: string;
  OIDC_CLIENT_ID: string;
  OIDC_REDIRECT_URI: string;
  OIDC_SILENT_REDIRECT_URI: string;
};

export const globalEnvValues = {
  BACKEND_URL: backendURL, //backendApiURL,
  DEFAULT_ACTION: 'defer',
  DEFAULT_VARIANT: 'default',
  FRONTEND_URL: frontendURL,
  // PEGA_APP: '',
  PEGA_APP: 'authorisation',
  // PEGA_APP: 'tilda',
  INACTIVITY_TIMEOUT_MS: 60 * 60 * 1000, // 60 minutes
  // OIDC_AUTHORITY: '${authURL}/oidc_pkce_pegapoc_tenant/.well-known/openid-configuration',
  OIDC_AUTHORITY: authURL + '/oidc_pkce_authorisation_tilda_tenant/.well-known/openid-configuration',
  // OIDC_AUTHORITY: authURL + '/oidc_pkce_pegapoc_tenant/.well-known/openid-configuration',
  // OIDC_AUTHORITY: authURL + '/oidc_pkce_pegapoc_tenant/',
  //OIDC_AUTHORITY: 'https://portalacc.finansinspektionen.se/oidc_pkce_pegapoc_tenant',
  // OIDC_CLIENT_ID: 'pega_pkce',
  OIDC_CLIENT_ID: 'tilda_pkce',
  OIDC_REDIRECT_URI: frontendURL + '/callback',
  OIDC_SILENT_REDIRECT_URI: frontendURL + '/silent',
}